AppConfig = require './AppConfig'
UADetector = require './modules/UADetector'
LayoutSequencer = require './modules/LayoutSequencer'
GnavCategorySlider = require './modules/GnavCategorySlider'
FooterSiteMap = require './modules/FooterSiteMap'
SearchAction = require './modules/SearchAction'

Header = require './modules/Header'
SideBar = require './modules/SideBar'

api = require './modules/Api'
tpl = require './modules/Tpl'

class App

  ###*
   * substr 文字省略
   * @param  {String} string
   * @param  {Number} len
   * @return {String}
  ###
  substr = (string, len)->
    _string = string
    if _string.length > len
      _string = _string.substr(0, len-1) + '…'
    return _string

  ###*
   * nl2br 改行コードをBRタグに変換
   * @param  {String} string 対象の文字列
   * @return {String}        変換後の文字列
  ###
  nl2br = (string)->
    return string.replace(/\r?\n/g, '<br />')

  ###*
   * br2nl BRタグを改行コードに変換
   * @param  {String} string 対象の文字列
   * @return {String}        変換後の文字列
  ###
  br2nl = (string)->
    return string.replace(/(<br>|<br \/>)/gi, '\n')

  constructor: ->

  init: ->

    @api = api
    @tpl = tpl
    api.init()

    @state =
      debugMode: false

    @uaDetector = new UADetector()

    @layoutSequencer = new LayoutSequencer()

    @sidebar = new SideBar()

    new Header()

    @util =
      substr: substr
      nl2br : nl2br
      br2nl : br2nl

    if AppConfig.IS_DEBUG
      @startDebug()

    new GnavCategorySlider()
    new FooterSiteMap()
    new SearchAction()


  startDebug: ->
    if @state.debugMode
      return false

    @state.debugMode = true

    if $('body').hasClass('is-oldIe')
      alert 'is Old IE'

    if $('body').hasClass('is-sp')
      alert 'is SP'

    if $('body').hasClass('is-tablet')
      alert 'is Tablet'

    console.log @layoutSequencer.getLayout()

    @layoutSequencer.on 'change', (state)->
      console.log state.currentLayout



global.app = new App()

$ ->
  app.init()



// WEBPACK FOOTER //
// ./src/scripts/app.coffee